// extracted by mini-css-extract-plugin
export default {"MemberSmall":"MemberSmall_MemberSmall__txz2e","card":"MemberSmall_card__1cBS5"};